import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";
import { useHistory } from 'react-router-dom';

import { Header, ProductDetails } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const EditProduct = withRouter(props => {

  const classes = useStyles();
  const [productobj , setProductobj] = useState({});
  const [userid, setUserid] = useState('');
  const [viewtype, setViewtype] = useState(1);
  const history = useHistory();

  const [masters, setMasters] = useState({
    commodity :[]
  });
  const snackbarCtx = React.useContext(SnackBarContext);

  const { sendNetworkRequest } = React.useContext(NetworkContext);


  async function fetchmasters()
  {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)
    
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {},false)
    //let versions = await sendNetworkRequest('/fetchappversions', {}, {},false)
    setMasters({
      ...masters,
      languages : [
        {
          id : 0,
          name : "All"
        },
        ...languages.module],
      commodity : commodities.module
    })
  }
  async function updateproductinfo(productdetails)
  {
  
    let prodinfo = await sendNetworkRequest('/admin/addproduct', {}, productdetails,false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: prodinfo.status,
      msg: prodinfo.message,
      vertical: "top",
    });
    history.push("/liveproducts");

  }
  async function fetchproductinfo(prodid)
  {
    let prodinfo = await sendNetworkRequest('/admin/getproductinfo', {}, {product_id : prodid},false)


    let product = {
      ...prodinfo.module
     }

     let prodlanguages = [];
     let prodlanguageids = prodinfo.module.languages

     if(masters && masters.languages)
     {
     masters.languages.forEach(element => {
       if(prodlanguageids.includes(""+element.id))
       {
        prodlanguages.push(element)
       }
     });
     product['language'] = prodlanguages
   }
   product['commodity'] = prodinfo.module.master_commodity
   product['subcommodity'] = prodinfo.module.master_sub_commodity
   let commodity_names = prodinfo.module.product_languages
  
   commodity_names.forEach(element => {
    product['name-'+element.master_language.name] = element.name
   });

   setProductobj(product)
  }
  useEffect(() => {
    var product_id = props.location.pathname.split('/')[2];
   // var viewtype = props.location.pathname.split('/')[3];
   
   // setUserid(user_id)
   
   if(product_id)
   {
    setViewtype(2)

     fetchproductinfo(product_id);
   }else
   {
    setViewtype(1)
   }
   
 }, [masters]);
  useEffect(() => {

    
    fetchmasters()
  }, []);

  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
     <ProductDetails usercontent={productobj} masters={masters} viewtype={viewtype} onUpdate={updateproductinfo}/>  
     
    </Page>
  );
});

export default EditProduct;
